/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { HardBlockedView } from './hardBlockedView';
import type { IneligibleView } from './ineligibleView';
import type { SyncableView } from './syncableView';
import type { SyncCosts } from './syncCosts';

export interface SyncPreflightResponse {
  syncable: SyncableView[];
  hard_blocked: HardBlockedView[];
  ineligible: IneligibleView[];
  resolved_count: number;
  truncated: boolean;
  costs: SyncCosts;
  balance: number;
  ats_display_name: string;
}
